import { render } from "./Table.vue?vue&type=template&id=5d01b5ae&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=5d01b5ae&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/Laravel/mistock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d01b5ae"]])

export default __exports__